import { ExternalLink, Sparkles } from "lucide-react";
import { MemberLink } from "@/components/build/MemberLink";
import { timeAgo } from "./PostCard";

// Creative Radar — Floor card (2026-08). `post.radar_entries`/`radar_stats` are exactly what
// modules/creative_radar.py's publish endpoint wrote — public-safe fields only, members linked
// by internal `freelancer_id` via the existing `MemberLink` component (never an external URL).
export function CreativeRadarCard({ post }) {
  const entries = post.radar_entries || [];
  const stats = post.radar_stats || {};

  return (
    <div className="rounded-2xl overflow-hidden border border-hairline bg-ink text-paper" data-testid={`radar-post-${post.id}`}>
      <div className="px-5 pt-5 pb-4 flex items-center justify-between border-b border-paper/10">
        <div className="flex items-center gap-2">
          <Sparkles className="h-5 w-5 text-brand" />
          <div>
            <div className="font-mont font-bold text-sm tracking-wide">CREATIVE RADAR</div>
            <div className="text-[11px] text-paper/60">{post.radar_period === "monthly" ? "Monthly" : "Weekly"} edition · {timeAgo(post.created_at)}</div>
          </div>
        </div>
        <div className="flex gap-3 text-[11px] text-paper/70">
          <span>{stats.new_collaborations_started ?? 0} new collabs</span>
          <span>{stats.assignments_completed ?? 0} wrapped</span>
        </div>
      </div>

      <div className="p-5 space-y-4">
        {entries.map((e, i) => (
          <div key={`${e.freelancer_id}-${i}`} className="flex items-start gap-3" data-testid={`radar-entry-${e.freelancer_id}`}>
            {e.thumbnail_url ? (
              <img src={e.thumbnail_url} alt="" className="w-14 h-14 rounded-lg object-cover shrink-0 border border-paper/10" loading="lazy" decoding="async" />
            ) : (
              <div className="w-14 h-14 rounded-lg bg-paper/10 flex items-center justify-center shrink-0 text-brand font-mont font-bold text-lg">
                {(e.name || "?")[0]}
              </div>
            )}
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <MemberLink freelancerId={e.freelancer_id} className="text-sm font-semibold text-paper hover:text-brand">{e.name}</MemberLink>
                <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-brand/20 text-brand">{e.category}</span>
              </div>
              <div className="text-xs text-paper/60">{e.role}{e.city ? ` · ${e.city}` : ""}</div>
              <div className="text-sm text-paper/90 mt-1 font-medium">{e.headline}</div>
              <p className="text-xs text-paper/70 mt-0.5">{e.summary}</p>
              {e.source_link && (
                <a href={e.source_link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[11px] text-brand mt-1 hover:underline">
                  View work <ExternalLink className="h-2.5 w-2.5" />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
